export const SAVE_VET_TICKET_PINNED = "SAVE_VET_TICKET_PINNED";
export const SAVE_VET_TICKET_UNPINNED = "SAVE_VET_TICKET_UNPINNED";

export const CLEAR_VET_TICKET_PINNED = "CLEAR_VET_TICKET_PINNED";
export const CLEAR_VET_TICKET_UNPINNED = "CLEAR_VET_TICKET_UNPINNED";
